import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, HeartIcon, CalendarIcon, MessageSquareIcon, AlertTriangleIcon, BookOpenIcon, TrophyIcon, LineChartIcon, UsersIcon, MenuIcon, XIcon } from 'lucide-react';
const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigationItems = [{
    name: 'Inicio',
    path: '/',
    icon: <HomeIcon size={18} data-id="element-38" />
  }, {
    name: 'Test de Diagnóstico',
    path: '/diagnostic-test',
    icon: <HeartIcon size={18} data-id="element-39" />
  }, {
    name: 'Tipo de Hombre',
    path: '/male-type',
    icon: <UsersIcon size={18} data-id="element-40" />
  }, {
    name: 'Biblioteca de Mensajes',
    path: '/messages',
    icon: <MessageSquareIcon size={18} data-id="element-41" />
  }, {
    name: 'Protocolo de Emergencia',
    path: '/emergency',
    icon: <AlertTriangleIcon size={18} data-id="element-42" />
  }, {
    name: 'Calendario',
    path: '/calendar',
    icon: <CalendarIcon size={18} data-id="element-43" />
  }, {
    name: 'Consolidación',
    path: '/consolidation',
    icon: <BookOpenIcon size={18} data-id="element-44" />
  }, {
    name: 'Casos de Éxito',
    path: '/success-stories',
    icon: <TrophyIcon size={18} data-id="element-45" />
  }, {
    name: 'Crecimiento Personal',
    path: '/personal-growth',
    icon: <LineChartIcon size={18} data-id="element-46" />
  }, {
    name: 'Comunidad',
    path: '/community',
    icon: <UsersIcon size={18} data-id="element-47" />
  }];
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <nav className="bg-[#2C2C2C] text-white shadow-md" data-id="element-48">
      <div className="container mx-auto px-4" data-id="element-49">
        <div className="flex justify-between items-center py-4" data-id="element-50">
          <div className="flex items-center" data-id="element-51">
            <h1 className="text-xl font-bold text-[#FFD700]" data-id="element-52">
              Mensajes Obsesivas
            </h1>
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-53">
            <button onClick={toggleMenu} className="text-white focus:outline-none" data-id="element-54">
              {isMenuOpen ? <XIcon size={24} data-id="element-55" /> : <MenuIcon size={24} data-id="element-56" />}
            </button>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-4" data-id="element-57">
            {navigationItems.slice(0, 5).map(item => <Link key={item.path} to={item.path} className={`flex items-center px-3 py-2 rounded-md text-sm font-medium ${location.pathname === item.path ? 'bg-[#E91E63] text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`} data-id="element-58">
                <span className="mr-2" data-id="element-59">{item.icon}</span>
                <span data-id="element-60">{item.name}</span>
              </Link>)}
          </div>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden" data-id="element-61">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-62">
              {navigationItems.map(item => <Link key={item.path} to={item.path} className={`flex items-center px-3 py-2 rounded-md text-sm font-medium ${location.pathname === item.path ? 'bg-[#E91E63] text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`} onClick={() => setIsMenuOpen(false)} data-id="element-63">
                  <span className="mr-2" data-id="element-64">{item.icon}</span>
                  <span data-id="element-65">{item.name}</span>
                </Link>)}
            </div>
          </div>}
      </div>
    </nav>;
};
export default Navigation;